<template>
<div class="common-seach-wrap">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="库存管理" name="stock"></el-tab-pane>

      <!-- <el-tab-pane label="管理员列表" name="basic"></el-tab-pane>
      <el-tab-pane label="测试" name="test"></el-tab-pane> -->
      <el-tab-pane label="管理员列表" name="authuser"></el-tab-pane>
    </el-tabs>
    <!--管理员-->
    <Stock v-if="activeName == 'stock'"></Stock>
    <AUTHAPP :type="'logistics'" :data_id="logistics_id" v-if="activeName == 'authuser'"></AUTHAPP>
  </div>
</template>
<script>
import LogisticsApi from '@/api/logistics.js';
import Stock from './part/stock';
// import Basic from './part/basic';
// import Test from './part/test';
import AUTHAPP from '@/views/auth_app/user/index';
export default {
  components: {
    Stock,
    AUTHAPP
  },
  data() {
    return {
      logistics_id:0,
      activeName:'stock',
      /*搜索表单*/
      searchForm: {},

    };
  },
  created() {
    /*获取列表*/
    this.logistics_id = this.$route.query.logistics_id;

  },
  methods: {
    
    handleClick(e) {
      this.activeName = e.name;
    }
  
  }
};
</script>

<style>
.bargain-task .user-info img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.bargain-task .product-pic {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/logistics/manager/index.vue